<template>
  <v-container class="px-0 py-0" fluid>
    <v-row dense>
      <v-col>
        <v-card outlined>
          <v-container fluid>
            <v-card outlined>
              <v-tabs fixed-tabs v-model="tab" @change="reset">
                <v-tab class="ml-0">{{ $t('ELE0086') }}</v-tab>
                <v-tab>{{ $t('ELE0213') }}</v-tab>
                <v-tab-item>
                  <ImpInspLotCSVForm ref="csvFormRef" />
                </v-tab-item>
                <v-tab-item class="pl-2 pt-1 pb-4">
                  <ImpInspLotQRForm />
                </v-tab-item>
              </v-tabs>
            </v-card>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ImpInspLotCSVForm from '@/components/organisms/terminal/form/ImpInspLotCSVForm'
import ImpInspLotQRForm from '@/components/organisms/terminal/form/ImpInspLotQRForm'

export default {
  name: 'ImpInspLotForm',

  components: {
    ImpInspLotCSVForm,
    ImpInspLotQRForm,
  },

  data() {
    return { tab: '' }
  },

  methods: {
    reset() {
      if (this.$refs.csvFormRef) {
        //CSVタブを切り替えたときにテーブル初期化
        if (this.tab !== 0) {
          this.$refs.csvFormRef.reset()
        }
      }
    },
  },
}
</script>
